import { useConsistentCharacterModalInit } from './ConsistentCharacterModal/init'

export function useInitPopups() {
  useConsistentCharacterModalInit()
}
